import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import { SaveBtn } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ItemTypeForm from './ItemTypeForm';
import storesMng from '../../api/storesMng';
import TopHeader from '../../../views/components/TopHeader';

import IBox from '@meronex/icons/fi/FiBox';

export default function EditItemTypeDialog(props) {
  const { open, onClose, onUpdate, itemType } = props;

  const validatedForm = React.useRef();

  const [formData, setFormData] = React.useState({});
  const [uploading, setUploading] = React.useState(false);

  const onSave = async () => {
    if (formData && formData.values) {
      const item = Object.assign(itemType, formData.values);

      delete item.added;
      try {
        await storesMng.updateStoreItemType(item);
        toast.success('Store type was successfully updated!');
      } catch (e) {
        toast.error(e.reason || 'Failed to update item type');
      }
      onClose();
      reset();
      onUpdate(item);
    }
  };

  function reset() {
    if (validatedForm.current) {
      validatedForm.current.reset();
    }
  }

  const _onClose = () => {
    reset();
    onClose();
  };

  if (!itemType) {
    return null;
  }

  return (
    <Dialog
      className={'fullScreenMobile'}
      open={open}
      onClose={_onClose}>
      <DialogTitle>
        <TopHeader
          title={'Update Item Type'}
          onClose={_onClose}
          icon={<IBox size={20} />}
        />
      </DialogTitle>
      <DialogContent>
        <ItemTypeForm
          itemType={itemType}
          ref={validatedForm}
          validateOnInit={true}
          onUpdate={(d) => {
            setFormData(d);
            setUploading(d.uploading);
          }}
        />
        <SaveBtn
          disabled={uploading || !formData.isValid}
          onClick={onSave}
          label={'Save'}
        />
      </DialogContent>
    </Dialog>
  );
}

EditItemTypeDialog.defaultProps = {
  onUpdate: () => {},
};
EditItemTypeDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onUpdate: PropTypes.func,
  itemType: PropTypes.object,
};
